export enum ServerApi {
  GENERATE_QR = `generate_qr`,
  DOWNLOAD_QR = `download_qr`,
  DOWNLOAD_BULK_QRS = `download_bulk_qrs`,
}
